import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "@atenea-cms";

import { AteneaModule } from "@atenea-cms";
import { DownloadsRoutes } from "./downloads.routes";
import { DownloadListComponent } from "./download-list/download-list.component";
import { DownloadFormComponent } from "./download-form/download-form.component";
import { DownloadService, DownloadFormService } from "./shared";

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    AteneaModule,
    DownloadsRoutes,
  ],
  declarations: [DownloadListComponent, DownloadFormComponent],
  providers: [DownloadService, DownloadFormService],
})
export class DownloadsModule {}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/downloads/downloads.module.ts